import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { select, Store } from '@ngrx/store';
import { catchError, filter, map, of, switchMap, withLatestFrom } from 'rxjs';

import { salesProductsApiActions } from './sales-products.actions';

import { selectSalesProductsLoaded } from './sales-products.selectors';

import { SalesProductsService } from '../../service/sales-products.service';

export class SalesProductsEffects {
  private actions$ = inject(Actions);
  private service = inject(SalesProductsService);
  private store = inject(Store);

  loadSalesProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(salesProductsApiActions.loadSalesProducts),
      withLatestFrom(this.store.pipe(select(selectSalesProductsLoaded))),
      filter(([, loaded]) => loaded === false),
      switchMap(() =>
        this.service.requestSalesProducts().pipe(
          map((salesProducts) => salesProductsApiActions.loadSalesProductsSuccess({ salesProducts })),
          catchError((error) => of(salesProductsApiActions.loadSalesProductsFailure({ error })))
        )
      )
    )
  );
}
